<template>
	<div id="clubClass_edu_index">
		<dv-full-screen-container class="bg">
			<dv-loading v-if="loading">Loading...</dv-loading>
			<div v-else class="host-body">
				<dialog-table v-if="Visible" ref="dialog" @closeWin="closeWin"></dialog-table>
				<div v-on:click="screen()"><dv-decoration-9 :color="['#55ffff', '#0090ff']" class="full_screen">{{
					screenName }}</dv-decoration-9></div>
				<!-- 第一行标题装饰条 -->
				<div class="d-flex jc-center title_bg">
					<div class="title">
						<span class="title-text">{{ areaName }}</span>
					</div>
				</div>
				<div class="body-box">
					<!-- 数据开始 -->
					<div class="w-100 content-box">
						<div class="main_grid">
							<!-- 第一列 -->
							<div style="height: 92vh;">
								<div class="l_block">
									<dv-border-box-10 :color="['#244b8a', '#83d0ff']">
										<left1 />
									</dv-border-box-10>
								</div>
								<div class="l_block">
									<dv-border-box-10 :color="['#244b8a', '#83d0ff']">
										<left2 />
									</dv-border-box-10>
								</div>
							</div>
							<!-- 第二列 -->
							<div style="height: 92vh;">
								<!-- 上半部分 -->
								<div class="mt_block">
									<div>
										<div class="text-center block_tnum"><b class="colorbluegreen">{{ orgNum }}</b></div>
										<div class="icon">
											<img class="block_circle" src="../../assets/img/block_circle.gif">
											<img class="jianbian_icon" src="../../assets/img/jianbian_icon.png">
											<img class="tea_icon" src="../../assets/img/school_icon.png">
										</div>
										<div class="text-center title-item mt_block_txt">学校总数</div>
									</div>
									<div>
										<div class="text-center block_tnum"><b class="colorbluegreen">{{ courseOrgNum }}</b>
										</div>
										<div class="icon">
											<img class="block_circle" src="../../assets/img/block_circle.gif">
											<img class="jianbian_icon" src="../../assets/img/jianbian_icon.png">
											<img class="tea_icon" src="../../assets/img/schchoose_icon.png">
										</div>
										<div class="text-center title-item mt_block_txt">开设服务学校</div>
									</div>
									<div>
										<div class="text-center block_tnum"><b class="colorbluegreen">{{ courseNum }}</b>
										</div>
										<div class="icon">
											<img class="block_circle" src="../../assets/img/block_circle.gif">
											<img class="jianbian_icon" src="../../assets/img/jianbian_icon.png">
											<img class="tea_icon" src="../../assets/img/book_icon.png">
										</div>
										<div class="text-center title-item mt_block_txt">服务课程</div>
									</div>
									<div>
										<div class="text-center block_tnum"><b class="colorbluegreen">{{ stuRatio }}</b>%
										</div>
										<div class="icon">
											<img class="block_circle" src="../../assets/img/block_circle.gif">
											<img class="jianbian_icon" src="../../assets/img/jianbian_icon.png">
											<img class="tea_icon" src="../../assets/img/stu_icon.png">
										</div>
										<div class="text-center title-item mt_block_txt">服务学生占比</div>

									</div>
								</div>
								<!-- 上半部分结束 -->
								<!-- 下半部分 -->
								<div class="mb_block">
									<dv-border-box-1 :color="['#244b8a', '#62c3ff']">
										<center1 />
									</dv-border-box-1>
								</div>
								<!-- 下半部分结束 -->
								<!-- 下半部分 -->
								<div class="mb_block">
									<dv-border-box-1 :color="['#244b8a', '#62c3ff']">
										<center2 />
									</dv-border-box-1>
								</div>
								<!-- 下半部分结束 -->
							</div>
							<!-- 第二列结束 -->
							<!-- 第三列开始 -->
							<div style="height: 92vh;">
								<!-- 1 -->
								<div class="r_block">
									<dv-border-box-10 :color="['#244b8a', '#69b9ff']">
										<right1 @showBigEven="showBigEven" />
									</dv-border-box-10>
								</div>
								<!-- 2 -->
								<div class="r_block">
									<dv-border-box-10 :color="['#244b8a', '#69b9ff']">
										<right2 />
									</dv-border-box-10>
								</div>
							</div>
							<!-- 第三列结束 -->
						</div>
					</div>
					<!-- 第四行数据结束 -->
				</div>
			</div>
		</dv-full-screen-container>
	</div>
</template>

<script>
var storage = window.localStorage;
var region = storage.getItem("region");
var orgCode = storage.getItem("orgCode");
import left1 from "./left1";
import left2 from "./left2";
import right1 from "./right1";
import right2 from "./right2";
import center1 from "./center1";
import center2 from "./center2";
import dialogTable from "./dialogtable";

export default {
	data() {
		return {
			loading: true,
			areaName: '',
			orgNum: 0,
			courseOrgNum: 0,
			courseNum: 0,
			stuRatio: 0,
			fullscreen: false,
			screenName: "全屏",
			Visible: false
		};
	},
	components: {
		dialogTable,
		left1,
		left2,
		right1,
		right2,
		center1,
		center2
	},
	mounted() {
		this.cancelLoading();
		this.initData();
		// 定时刷新时间
		let _this = this;
		// 定时器刷新，1天
		setInterval(() => {
			_this.initData();
		}, 1000 * 60 * 60 * 24);
	},
	methods: {
		showBigEven(data) {
			console.log("父页面:" + data);
			// data为子页面的传过来的数据
			this.Visible = true;
		},
		closeWin() {
			this.Visible = false;
		},
		//关闭loading加载条
		cancelLoading() {
			setTimeout(() => {
				this.loading = false;
			}, 2000);
		},
		initData() {
			let _this = this;
			var type = this.$route.query.type;
			//判断访问客户端类型
			if (type == 'window') {
				_this.screenName = "全屏";
			} else {
				_this.screenName = "返回";
			}
			this.$http.get("/dataView/getNameByRedion?regionId=" + region).then(res => {
				if (res.data.code === 200) {
					_this.areaName = res.data.result + '教育局';
				}
			});
			this.$http.get("/dataView/clubClass/edu/getIndexInfo?orgCode=" + orgCode).then(res => {
				if (res.data.code === 200) {
					var result = res.data.result;
					_this.orgNum = result.orgNum;
					_this.courseOrgNum = result.courseOrgNum;
					_this.courseNum = result.courseNum;
					_this.stuRatio = Math.round(result.stuRatio);
				}
			});
		},
		//点击全屏
		screen: function () {
			var type = this.$route.query.type;
			//判断访问客户端类型
			if (type == 'window') {
				let _this = this;
				let element = document.documentElement;
				if (_this.fullscreen) {
					if (document.exitFullscreen) {
						document.exitFullscreen();
					} else if (document.webkitCancelFullScreen) {
						document.webkitCancelFullScreen();
					} else if (document.mozCancelFullScreen) {
						document.mozCancelFullScreen();
					} else if (document.msExitFullscreen) {
						document.msExitFullscreen();
					}
					_this.screenName = "全屏";
				} else {
					if (element.requestFullscreen) {
						element.requestFullscreen();
					} else if (element.webkitRequestFullScreen) {
						element.webkitRequestFullScreen();
					} else if (element.mozRequestFullScreen) {
						element.mozRequestFullScreen();
					} else if (element.msRequestFullscreen) {
						element.msRequestFullscreen();
					}
					_this.screenName = "取消";
				}
				_this.fullscreen = !_this.fullscreen;
			} else {
				//window.AndroidWebView.finish();
				this.$router.replace('/dataView/appIndex?area=' + region);
			}
		}
	},
	// 注意在vue实例销毁前，清除我们的定时器。
	destroyed() {
		if (this.timer) {
			clearInterval(this.timer)
		}
	}
};
</script>

<style lang="scss">
@import "../../assets/scss/clubClassIndexEdu.scss";

#clubClass_edu_index {
	.title_bg {
		width: 100%;
		height: 7vh;
		background: url("../../assets/img/afterclass_titbg.png") center no-repeat;
	}

	.title {
		width: 100%;
		text-align: left;

		.title-text {
			display: inline-block;
			font-size: 0.25rem !important;
			font-weight: bold;
			line-height: 0.25rem;
			margin-left: 2.3rem;
			margin-top: 0.2rem;
			background-image: linear-gradient(135deg, #55ffff, #54c3ff);
			-webkit-background-clip: text;
			color: transparent;
		}
	}

	.mt_block {
		height: 20vh;
		display: grid;
		grid-template-columns: 1fr 1fr 1fr 1fr;
		margin: 0 0.5rem;
		font-size: 0.19rem;
		padding-top: 0.65rem;
		color: #42c3ff;
		overflow: hidden;
	}

	.mt_block .icon {
		// 新增
		position: relative;
		height: 70px;
		width: 70px;
		margin: 0 auto;
		perspective: 180px;
	}

	.mt_block .block_circle {
		// 新增
		position: absolute;
		transform: rotateX(70deg);
	}

	.mt_block img.block_circle {
		width: 100%;
	}

	.mt_block .jianbian_icon {
		// 新增
		position: absolute;
		bottom: 0.18rem;
		left: -0.15rem
	}

	.mt_block .tea_icon {
		// 新增
		position: absolute;
		bottom: 0.6rem;
		left: 0.28rem
	}

	.mt_block img.tea_icon {
		width: 0.4rem;
	}

	.mt_block_txt {
		margin-top: -0.15rem;
	}

	.block_tnum {
		font-size: 0.25rem;
		margin-bottom: 0.15rem;
	}

	.block_tnum b {
		font-size: 0.4rem;
	}

	.l_block {
		margin: 0.22rem 0;
		height: 44.5vh;
	}

	.r_block {
		margin: 0.2rem 0;
		height: 44.5vh;
	}

	.mb_block {
		height: 35.5vh;
		margin: 0.1rem 0;
		padding: 0 0.2rem;
	}
}
</style>